<!-- 客户预收款、供应商预付款 -->
<template>
    <div v-loading="loading" class="builda-infoes">
        <el-form :rules="rules" :model="submitData" label-width="80px" ref="submitData">
            <el-form-item :label="CType == 0 ? '客户' : '供应商'" prop="EntpCusId">
                <el-select
                    size="small"
                    v-model="submitData.EntpCusId"
                    filterable
                    clearable
                    remote
                    reserve-keyword
                    :remote-method="querySearch"
                    v-select-scroll-more="searchLoad"
                    style="width: 100%"
                >
                    <el-option v-for="optionItem in cusOptions" :key="optionItem.EntpCusId" :data-msg="optionItem" :label="optionItem.EntpCusName" :value="optionItem.EntpCusId">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="原金额" prop="TotalAmount" v-if="IsEdit">
                <el-input size="small" type="number" disabled v-model="CurrentData.TotalAmount" :min="0" style="width: 100%"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="已用金额" prop="AlreadyPaid">
                <el-input size="small" type="number" disabled v-model="CurrentData.AlreadyPaid" :min="0" style="width: 100%"></el-input>
            </el-form-item> -->
            <el-form-item label="支付方式" prop="PayType">
                <el-select style="width: 100%" size="small" v-model="submitData.PayType" placeholder="请选择">
                    <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="CType == 0 ? '预收金额' : '预付金额'" prop="CollectionAmount">
                <el-input size="small" type="number" step="0.01" v-model="submitData.CollectionAmount" :min="0" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item :label="CType == 0 ? '收款日期' : '付款日期'" prop="PayDate">
                <el-date-picker style="width: 100%" size="small" v-model="submitData.PayDate" align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="备注">
                <el-input size="small" v-model="submitData.Remark" style="width: 100%"></el-input>
            </el-form-item>
        </el-form>
        <div class="btn-ctn">
            <el-button size="small" class="search-btn" @click="cancel()">取消</el-button>
            <el-button size="small" class="search-btn btn-primary" @click="submitForm()">提交</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['CurrentData', 'CType', 'IsEdit'],
    components: {},
    data() {
        return {
            loading: false,
            payWayList: [],
            submitData: {
                CollectionAmount: 0,
                EntpCusId: '',
                Remark: '',
                CType: 0,
                RecordId: '',
                PayType: '',
                PayDate: ''
            },
            rules: {
                PayType: [{ required: true, message: '该项必选', trigger: 'change' }],
                PayDate: [{ required: true, message: '该项必选', trigger: 'change' }],
                EntpCusId: [{ required: true, message: '该项必选', trigger: 'change' }],
                CollectionAmount: [{ required: true, message: '该项必填', trigger: 'change' }]
            },
            tableData: [],
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    },
                    {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    created(){
         //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);

        this.submitData.PayDate = date1;
    },
    mounted() {
        if (this.CType !== null && this.CType !== undefined) {
            this.submitData.CType = this.CType;
        } else {
            this.$util.warningMsg('预收(付)实体信息异常，请刷新后重新操作');
            return;
        }
        this.getPay();
        this.querySearch();
    },
    methods: {
        cancel() {
            this.$emit('closeDialog');
        },
        submitForm() {
            this.$refs.submitData.validate(valid => {
                let that = this;
                if (valid) {
                    if (this.submitData.CollectionAmount == 0) {
                        this.$util.warningMsg('预收(付)金额不能等于0');
                        return;
                    }
                    this.$confirm(this.IsEdit ? '您确定要修改该条账款吗？' : '您确认要提交预收(付)款项吗？', '提示', {
                        confirmButtonText: this.IsEdit ? '确定修改' : '确定提交',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: false
                    })
                        .then(() => {
                            this.$refs['submitData'].validate(valid => {
                                if (valid) {
                                    this.loading = true;
                                    this.$util
                                        .axiosPost({
                                            url: '/api/RevenueManagement_H/ApplyAdvanceReceivedRecords',
                                            data: this.submitData,
                                            hideLoading: true
                                        })
                                        .then(res => {
                                            if (this.IsEdit) this.$util.successMsg('修改成功');
                                            else this.$util.successMsg('提交成功');
                                            this.submitData.CollectionAmount = 0;
                                            this.submitData.Remark = '';
                                            this.submitData.RecordId = '';
                                            this.$emit('closeDialog', true);
                                        })
                                        .finally(() => {
                                            this.loading = false;
                                        });
                                } else {
                                    return false;
                                }
                            });
                        })
                        .catch(() => {});
                } 
            });
        },
        //  结算方式
        getPay() {
            this.$util.getPay(1).then(data => {
                this.payWayList = data;
            });
        },
        async querySearch(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            let data = {};
            switch (this.CType) {
                case 0:
                    data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
                    break;
                case 1:
                    data = await this.$util.searchSupplier(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
                    break;
                default:
                    this.$util.warningMsg('预收(付)实体信息异常，请刷新后重新操作');
                    return;
            }
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchLoad() {
            this.cusForm.Page += 1;
            this.querySearch();
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-content {
    margin: 5px;
}
.btn-ctn {
    text-align: right;
}
.builda-infoes {
    padding-top: 10px;
    padding-bottom: 10px;
    width: 340px;
    height: auto;

    .dialog-footer {
        text-align: right;
    }
    .el-form-item {
        margin-bottom: 0;
    }
}
</style>
